import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./contract.scss";
import SignatureCanvas from "react-signature-canvas";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import party from "party-js";
import Tick from "../animations/Tick";
import moment from "moment";
import Layout from "../Layout";

party.settings.debug = false;
party.resolvableShapes[
  "logo"
] = `<img width="32px" src="https://i.pinimg.com/originals/eb/e4/9c/ebe49c9609b15a98b84de9f2b057b16f.png"/>`;

const confettiSettings = {
  shapes: [
    "square",
    "rectangle",
    "roundedSquare",
    "circle",
    "roundedRectangle",
    "star",
    // "logo"
  ],
  // The amount of confetti particles that should be emitted.
  count: party.variation.range(80, 200),
  // The amount of spread that is applied to the emission angle. Note that the default angle points upwards.
  spread: 30,
  // The initial speed that the confetti particles are emitted with.
  speed: party.variation.range(50, 600),
  // The initial size that the confetti particles are emitted with.
  size: party.variation.skew(1, 0.8),
  // The initial rotation that the confetti particles are emitted with.
  rotation: () => party.random.randomUnitVector().scale(180),
  // The initial color that particles are emitted with.
  color: () =>
    party.random.pick([
      party.Color.fromHex("#238446"),
      party.Color.fromHex("#1D7DB2"),
      party.Color.fromHex("#FFC800"),
      party.Color.fromHex("#FFFFFF"),
    ]),
};

// Shared typography treatment for clause headings/body so the long-form
// contract reads cleanly as one continuous column on mobile and desktop.
const clauseHeadingSx = {
  fontStyle: "italic",
  fontWeight: 700,
  textTransform: "uppercase",
  color: "primary.dark",
  mt: 3,
  mb: 1,
};

const clauseBodySx = {
  lineHeight: 1.6,
  mb: 2,
};

export default function Contract() {
  const [data, setData] = useState({});
  const [signature, setSignature] = useState("");
  const [tick, setTick] = useState(false);
  const navigate = useNavigate();
  const [dbid, setDbid] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);
  const [managerContract, setManagerContract] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [breaks, setBreaks] = useState(false);
  const [isWarehouse, setIsWarehouse] = useState(false);
  const [isStrathclyde, setIsStrathclyde] = useState(false);
  const [probationDuration, setProbationDuration] = useState("");
  const [noDetails, setNoDetails] = useState(false);
  const [ip, setIp] = useState("");
  const [promotion, setPromotion] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const signButtonRef = useRef(null);
  const url = process.env.REACT_APP_HR_API_URL;
  document.title = "Onboarding | Contract";

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get("id");
    const token = queryParams.get("token");
    if (token) sessionStorage.setItem("onboardingToken", token);
    setDbid(userId);

    if (userId && userId.includes("pr")) {
      setPromotion(true);
    }
    const headers = sessionStorage.getItem("onboardingToken") ? { "x-onboarding-token": sessionStorage.getItem("onboardingToken") } : {};
    axios
      .get(`${url}/onBoard/new-start/${userId}`, { headers })
      .then((res) => {
        //console.log("request answer:", res.data);
        if (
          res.data.position.toLowerCase().includes("manager") ||
          res.data.company === "Head Office" ||
          (res.data.company === "Nitro Solutions 23 Ltd" &&
            res.data.position !== "Warehouse Assistant" &&
            res.data.position !== "Warehouse Packer")
        ) {
          setManagerContract(true);
          setBreaks(true);
        }
        if (
          res.data.position.includes("Supervisor") ||
          res.data.position.includes("Leader") ||
          res.data.companyName.includes("RTMS")
        ) {
          setBreaks(true);
        }

        if (
          res.data.position === "Warehouse Assistant" ||
          res.data.position === "Warehouse Packer"
        ) {
          setIsWarehouse(true);
        }

        if (
          res.data.companyName.toLowerCase().includes("rt st james ltd") &&
          !res.data.position.toLowerCase().includes("manager")&&
          !res.data.position.toLowerCase().includes("supervisor")
        ) {
          setIsStrathclyde(true);
        }

        var compAddress = "";

        if (
          res.data.company === "Head Office" ||
          res.data.company === "Nitro Solutions 23 Ltd"
        ) {
          if (
            res.data.position.toLowerCase().includes("warehouse") ||
            res.data.position.toLowerCase().includes("operative") ||
            res.data.position === "Baking Assistant"
          ) {
            compAddress = "70 Johnstone Avenue, Hillington, Glasgow, G52 4JT";
          } else {
            compAddress =
              "St James Church, 30 Underwood Road, Paisley, PA3 1TL";
          }
        } else {
          compAddress = `${res.data.addressLine1}, ${res.data.city}, ${res.data.postcode}`;
        }

        if (res.data._id) {
          setData(res.data);
        } else {
          //console.log(res.data);
          let hourly;
          if (res.data.salaryHourly) {
            hourly = res.data.salaryHourly;
          } else if (res.data.salaryYearly) {
            hourly = res.data.salaryYearly;
          }
          //calculates duration of the probation

          let probation = moment(res.data.probationDate, "YYYY-MM-DD");
          let startDate = moment(res.data.startDate, "YYYY-MM-DD");

          let probationTime = probation.diff(startDate, "months");
          setProbationDuration(probationTime);
          let data = {
            company: res.data.companyName,
            address: compAddress,
            firstName: res.data.firstName,
            middleName: null,
            lastName: res.data.lastName,
            startDate: new Date(res.data.startDate).toLocaleDateString("en-GB"),
            probationDate: new Date(res.data.probationDate).toLocaleDateString(
              "en-GB"
            ),

            promotionStart: res.data.promotionStart,

            position: res.data.position,
            hourly: hourly,
            noticePeriod: res.data.noticePeriod,
            contract: res.data.contractedHours,
            shiftHours: parseFloat(res.data.contractedHours) >= 45 ? 9 : 8,
          };

          if (res.data.probation) {
            data.probationDate = res.data.probation;
          }

          if (res.data.middleName !== null) {
            data.middleName = res.data.middleName;
          }
          setData(data);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          setNoDetails(true);
        }
      });

    axios
      .get("https://api.ipify.org/?format=json")
      .then((res) => {
        setIp(res.data.ip);
      })
      .catch(() => {});
  }, [url]);

  const sign = () => {
    if (submitting) return;
    if (signature.isEmpty()) {
      setMessage("Please sign the contract");
      setSeverity("error");
      setErrorAlert(true);
      setTimeout(() => {
        setErrorAlert(false);
        setMessage("");
        setSeverity("");
      }, 3500);
      return;
    }
    setSubmitting(true);
    const signatureData = signature.getTrimmedCanvas().toDataURL("image/png");
    let details = {
      id: dbid,
      signature: signatureData,
      ipAddress: ip,
    };
    sessionStorage.setItem("site", JSON.stringify(data.company));
    sessionStorage.setItem("staff", JSON.stringify(data.firstName));
    const token = sessionStorage.getItem("onboardingToken");
    const headers = token ? { "x-onboarding-token": token } : {};
    axios
      .post(`${url}/onBoard/new-start/contractReceived`, details, { headers })
      .then((res) => {
        setTick(true);
        setTimeout(() => {
          setTick(false);
          if (signButtonRef.current) {
            party.confetti(signButtonRef.current, confettiSettings);
          }
          setTimeout(() => {
            navigate(`/contract-completed`);
          }, 500);
        }, 2500);
      })
      .catch((err) => {
        setMessage("Something went wrong, please try again");
        setSeverity("error");
        setErrorAlert(true);
        setTimeout(() => {
          setErrorAlert(false);
          setMessage("");
          setSeverity("");
        }, 3500);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: { xs: 3, sm: 5 } }}>
        {!noDetails ? (
          <>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Typography
                variant="h5"
                sx={{
                  textTransform: "uppercase",
                  fontStyle: "italic",
                  fontWeight: 700,
                }}
              >
                Statement of Main Terms of Employment
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontStyle: "italic", mt: 1.5, lineHeight: 1.6 }}
              >
                This Statement, together with the Employee Handbook, forms part of
                your Contract of Employment (except where the contrary is
                expressly stated) and sets out particulars of the main terms on
                which
              </Typography>
              <Divider sx={{ width: "40%", mx: "auto", mt: 2.5 }} />
            </Box>

            <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, mb: 3, textAlign: "center" }}>
              <Typography variant="h4">{data.company}</Typography>
              <Typography variant="h6" color="text.secondary" sx={{ mt: 0.5 }}>
                {data.address}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Employs:
              </Typography>
              <Typography variant="h5">
                {data.firstName} {data.middleName} {data.lastName}
              </Typography>
            </Paper>

            <Paper variant="outlined" sx={{ p: { xs: 2, sm: 4 } }}>
              {!promotion ? (
                <Typography variant="body1" sx={clauseBodySx}>
                  Your employment began on {data.startDate}. No previous
                  employment counts as part of your period of continuous
                  employment. You will serve a probationary period of{" "}
                  {probationDuration} months that will be reviewed on{" "}
                  {data.probationDate}.
                </Typography>
              ) : (
                <Typography variant="body1" sx={clauseBodySx}>
                  Your employment began on {data.startDate}. You were made{" "}
                  {data.position} from{" "}
                  {moment(data.promotionStart, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                  )}{" "}
                  and this counts as part of your previous continuous
                  employment, subject to probationary review on:{" "}
                  {moment(data.probationDate, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                  )}
                  .
                </Typography>
              )}
              <Typography variant="h6" sx={clauseHeadingSx}>
                Job Title
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                You are employed as a {data.position} and your duties will be as
                advised by your Manager. Your duties may be modified from time
                to time to suit the needs of the business.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Place of Work
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                You will normally be required to work at {data.company} at{" "}
                {data.address}
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                You may be asked to work at any of our other sites as required
                by the needs of the business and you will be given notice of no
                less than 5 working days. You will not be required to work
                outside the United Kingdom.
              </Typography>
              {isWarehouse ? (
                <>
                  <Typography variant="h6" sx={clauseHeadingSx}>
                    Hours of Work
                  </Typography>
                  <Typography variant="body1" sx={clauseBodySx}>
                    Your contracted hours of work are {data.contract} per week.
                    The business is opened 24 hours a day, you will normally be
                    required to work an {data.shiftHours}-hour shift as per the
                    weekly rota, this will include evenings, nights and weekend
                    working. If you work six hours or more in any one shift you
                    will be entitled to a 20-minute unpaid break. You may be
                    required to work additional hours when authorised, and as
                    necessitated by the needs of the business.
                  </Typography>
                </>
              ) : (
                <>
                  <Typography variant="h6" sx={clauseHeadingSx}>
                    Job Status
                  </Typography>
                  {breaks ? (
                    <Typography variant="body1" sx={clauseBodySx}>
                      You are employed on an {data.contract} hour contract. You
                      will normally be required to work an {data.shiftHours}
                      -hour shift as per the weekly rota, this will include
                      evenings, nights and weekend working. If you work six
                      hours or more in any one shift you will be entitled to a
                      30-minute unpaid break. You may be required to work
                      additional hours when authorised and as necessitated by
                      the needs of the business.
                    </Typography>
                  ) : (
                    <Typography variant="body1" sx={clauseBodySx}>
                      You are employed on an {data.contract} hour contract. You
                      will normally be required to work an {data.shiftHours}
                      -hour shift as per the weekly rota, this will include
                      evenings, nights and weekend working. If you work six
                      hours or more in any one shift you will be entitled to a
                      20-minute unpaid break. You may be required to work
                      additional hours when authorised and as necessitated by
                      the needs of the business.
                    </Typography>
                  )}
                </>
              )}

              {isStrathclyde && (
                <>
                  <Typography variant="h6" sx={clauseHeadingSx}>
                    Guaranteed Minimum of 8 Hours (Non-Term Time)
                  </Typography>
                  <Typography variant="body1" sx={clauseBodySx}>
                    The Employee is employed on a part-time basis and is guaranteed a minimum of 8 hours’ work per week.
                    The Employee’s actual working hours may vary from week to week in accordance with the operational needs of the business.
                    The Employee acknowledges that the Company experiences periods of reduced activity, particularly during non-term time or other periods of lower demand (“Quiet Periods”).
                    During such periods, the Company may temporarily reduce the Employee’s working hours,
                    provided that the minimum guaranteed hours of 8 hours per week are maintained, where this is reasonably necessary to ensure the continued operation of the business.
                    Any variation to working hours will be applied fairly and proportionately and will be communicated to the Employee with reasonable notice.
                    As the Employee is paid on an hourly basis, remuneration will vary in line with the hours worked.
                    The Company will use reasonable endeavours to increase the Employee’s working hours when business demand allows.
                  </Typography>
                </>
              )}

              <Typography variant="h6" sx={clauseHeadingSx}>
                Other Employment
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                If you already have any other employment or are considering any
                additional employment you must notify us so that we can discuss
                any implications arising from the current working time
                legislation.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Probationary Period
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                You join us on an initial probationary period of six months.
                Your probationary review will be held {data.probationDate}.
                During this period your work performance and general suitability
                will be assessed and, if it is satisfactory, your employment
                will continue. However, if your work performance is not up to
                the required standard, or you are considered to be generally
                unsuitable, we may either take remedial action (which may
                include the extension of your probationary period) or terminate
                your employment at any time. We reserve the right not to apply
                our full contractual capability and disciplinary procedures
                during your probationary period.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Employee Training
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                At the commencement of your employment, you will receive
                training for your specific job, and as your employment
                progresses your skills may be extended to encompass new job
                activities within the business. It is a condition of your
                employment that you participate in any training deemed necessary
                by us for you to reach the required levels of attainment
                standards.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Remuneration
              </Typography>
              {managerContract ? (
                <Typography variant="body1" sx={clauseBodySx}>
                  Your salary is currently {data.hourly} per annum payable
                  monthly in arrears by BACs as detailed on your pay statement.
                  In your first year of employment your salary will be
                  proportionate to the amount of time left in the year. This
                  salary is pro-rated from your contracted hours. Any additional
                  hours worked will be paid at your normal hourly rate.
                </Typography>
              ) : (
                <Typography variant="body1" sx={clauseBodySx}>
                  Your current hourly rate is: {data.hourly}. Payable monthly in
                  arrears by BACs as detailed on your pay statement. In your
                  first year of employment your salary will be proportionate to
                  the amount of time left in the year. Any additional hours
                  worked will be paid at your normal hourly rate.
                </Typography>
              )}
              <Typography variant="h6" sx={clauseHeadingSx}>
                Deductions From Pay
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                As a part of our Deductions from Pay Agreement Policy, you will
                sign a declaration upon commencing employment which outlines
                your responsibilities and obligations as an employee. Conditions
                relating to this are shown in the Deductions and Pay Agreement
                Form found in the New Starter Form to which you should refer.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Any uniform provided is company property. Therefore, when
                commencing employment with us, if you are given any uniform, you
                will sign a document which states that on termination of your
                employment, you are required to return your uniform once
                laundered within 5 days. Failure to do so will result in the
                cost of these items being deducted from your wages.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Collective Agreements
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                No collective agreements directly affect your terms and
                conditions of employment.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Annual Leave and Public Bank Holidays
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Your holiday year begins on 1st January and ends on 31st
                December each year, during which you will receive a paid holiday
                entitlement of 5.6 working weeks inclusive of any public/bank
                holidays which you may choose to request. In your first holiday
                year your entitlement will be proportionate to the amount of
                time left in the holiday year.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                However, because of the nature of our business you may be
                required to work on any of the public/bank holidays and it is a
                condition of employment that you work on these days when
                required to do so.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Where Christmas Day or New Year's Day is worked, payment will be
                made at double time.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Conditions relating to the taking of holidays are shown in the
                Employee Handbook to which you should refer.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                In the event of termination of employment holiday entitlement
                will be calculated as 1/12 of the annual entitlement for each
                completed month of service during that holiday year and any
                holidays accrued but not taken will be paid for. However, in the
                event of you having taken any holidays in the current holiday
                year, which have not been accrued pro-rata, then the appropriate
                payments will be deducted from your final pay.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Sickness Pay and Conditions
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                There is no contractual sickness/injury payments scheme in
                addition to SSP. Conditions relating to this are shown in the
                Employee Handbook to which you should refer.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Maternity/Paternity/Adoption Leave and Pay
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                You may be entitled to maternity/paternity/adoption leave and
                pay in accordance with the current statutory provisions.
                Employees are entitled to Statutory Maternity Pay if you have
                worked for the Company continuously for at least 26 weeks. If
                you (or your partner) become pregnant or are notified of a match
                date for adoption purposes you should notify the Manager or the
                Recruitment/HR Officer at an early stage so that your
                entitlements and obligations can be explained to you. Employees
                must tell their employer about the pregnancy at least 15 weeks
                before the beginning of the week the baby is due.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Employees are required to give evidence to the Company of the
                expected week of confinement, such evidence would normally be in
                the form MAT B1 and should be provided as soon as possible to
                the Manager. Employees must inform the Company in writing at
                least 28 days before the beginning of their expected absence
                from work due to pregnancy.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Statutory Maternity Pay is payable for a maximum of 39 weeks,
                and can start from the 11th week before the baby is due, no
                earlier – but may be later. Employees should inform the Company
                in writing of when they wish to receive any Statutory Maternity
                Pay to which they are entitled. Statutory Maternity Pay will be
                paid in intervals.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Employees will be entitled to Statutory Paternity Pay at the
                rate according to the rules set out in current legislation.
                Statutory Paternity Pay is payable for 2 weeks, within 8 weeks
                of birth or adoption. Employees must inform the HR Officer 15
                weeks before the baby is due by completing SC3 Form, so that we
                can discuss your entitlements and obligations can be explained
                to you.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Capability and Disciplinary Procedures
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                The disciplinary rules that form part of your contract of
                employment and the procedures that will apply when dealing with
                capability or disciplinary issues are shown under the headings
                “Capability Procedures” and “Disciplinary Procedures” in the
                Employee Handbook to which you should refer.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Capability/Disciplinary Appeal Procedure
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Should you be dissatisfied with any decision to take action or
                dismiss you on capability/disciplinary grounds, you should
                apply, either verbally or in writing, to the Director within
                five working days of the decision you are complaining against.
                Further information can be found in the Employee Handbook under
                the heading “Capability/Disciplinary Appeal Procedure” to which
                you should refer.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Grievance Procedure
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                Should you feel aggrieved at any matter relating to your
                employment, you should raise the grievance with the
                Recruitment/HR Officer or the Manager, either verbally or in
                writing. Further information can be found in the Employee
                Handbook.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Termination of Employment
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                If you terminate your employment without giving or working the
                required period of notice, as indicated in your individual
                Statement of Main Terms of Employment, you will have an amount
                equal to any additional cost of covering your duties during the
                notice period not worked deducted from any termination pay due
                to you. This is an express written term of your contract of
                employment. You will also forfeit any contractual accrued
                holiday pay due to you over and above your statutory holiday
                pay, if you fail to give or work the required period of notice.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Notice of Termination to be Given by Employer
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>Under 1 month’s service - Nil.</Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                1 month but less than 2 years’ service – 1 Weeks.
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                2 years’ service or more - 1 week for each completed year of
                service to a maximum of 12 weeks after 12 years
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Notice of Termination to be Given by Employee
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>Under 1 month’s service – Nil.</Typography>
              {data.noticePeriod ? (
                <Typography variant="body1" sx={clauseBodySx}>
                  1 month's service or more - {data.noticePeriod}
                </Typography>
              ) : (
                <Typography variant="body1" sx={clauseBodySx}>1 month’s service or more - 2 Weeks</Typography>
              )}
              <Typography variant="body1" sx={clauseBodySx}>
                We reserve the right not to apply our full contractual
                capability and disciplinary procedures during your probationary
                period, which includes notice of termination from the employer.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Pay in Lieu of Notice
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                We reserve the contractual right to give pay in lieu of all or
                any part of the above notice by either party.
              </Typography>
              <Typography variant="h6" sx={clauseHeadingSx}>
                Pension and Pension Scheme
              </Typography>
              <Typography variant="body1" sx={clauseBodySx}>
                When required, we will operate a contributory pension scheme to
                which you will be auto-enrolled into (subject to the conditions
                of the scheme). Further details are available from the HR Team.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="body1" sx={{ fontWeight: 700, mb: 1.5 }}>
                For and on behalf of the Employer:
              </Typography>
              <Box
                component="img"
                src="https://staff.racetrackpitstop.co.uk/wp-content/uploads/2021/10/shamly_sig.png"
                alt="Director signature"
                sx={{ maxWidth: 220, display: "block", mb: 3 }}
              />
              <Typography variant="body1" sx={clauseBodySx}>
                I acknowledge receipt of this statement and agree that, for the
                purpose of the Working Time Regulations, any applicable
                entitlements and provisions constitute a Relevant Agreement.
              </Typography>

              <Box sx={{ mt: 3 }}>
                <Typography variant="body1" sx={{ fontWeight: 700, mb: 1.5 }}>
                  Employee signature:
                </Typography>

                <Paper
                  variant="outlined"
                  sx={{
                    p: 1,
                    width: "100%",
                    maxWidth: 600,
                    borderRadius: 2,
                  }}
                >
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{ className: "sigCanvas" }}
                    ref={(ref) => {
                      setSignature(ref);
                    }}
                  />
                </Paper>

                <Stack direction="row" spacing={2} sx={{ mt: 1.5, flexWrap: "wrap" }}>
                  <Button color="error" onClick={() => signature.clear()}>
                    Clear Signature
                  </Button>
                </Stack>

                {errorAlert ? (
                  <Alert severity={severity} sx={{ mt: 2 }}>
                    {message}
                  </Alert>
                ) : (
                  <></>
                )}

                <Button
                  ref={signButtonRef}
                  variant="contained"
                  endIcon={<SendIcon />}
                  color="error"
                  onClick={() => sign()}
                  id="sign__btn"
                  disabled={submitting}
                  sx={{
                    mt: 2,
                    width: { xs: "100%", sm: "auto" },
                    display: submitting ? "none" : undefined,
                  }}
                >
                  Send
                </Button>

                {tick ? <Tick /> : <></>}
              </Box>
            </Paper>
          </>
        ) : (
          <Box sx={{ textAlign: "center", py: 6 }}>
            <Typography variant="h6">
              Can not find any details for this individual.
            </Typography>
          </Box>
        )}
      </Container>
    </Layout>
  );
}
